module.exports = __webpack_public_path__ + "static/img/sxjgk_icon.png";